import { render, staticRenderFns } from "./deviceWorkerDealStart.vue?vue&type=template&id=0058a4de&scoped=true&"
import script from "./deviceWorkerDealStart.vue?vue&type=script&lang=js&"
export * from "./deviceWorkerDealStart.vue?vue&type=script&lang=js&"
import style0 from "./deviceWorkerDealStart.vue?vue&type=style&index=0&id=0058a4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058a4de",
  null
  
)

export default component.exports